import {
    GET_CITY_DEFINITIONS,
    GET_CITY_DEFINITIONS_SUCCESS,
    ADD_CITY_DEFINITION,
    ADD_CITY_DEFINITION_SUCCESS,
    UPDATE_CITY_DEFINITION,
    UPDATE_CITY_DEFINITION_SUCCESS,
    DELETE_CITY_DEFINITION,
    DELETE_CITY_DEFINITION_SUCCESS,
    API_ERROR
  
  } from "./actionTypes"
  
  
  
  
  export const getCityDefinition = () => ({
    type: GET_CITY_DEFINITIONS,
  })
  
  export const getCityDefinitionSuccess = record => ({
    type: GET_CITY_DEFINITIONS_SUCCESS,
    payload: record,
  })
  
  export const addCityDefinition = record => ({
    type: ADD_CITY_DEFINITION,
    payload: record,
  })
  
  export const addCityDefinitionSuccess = record => ({
    type: ADD_CITY_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const updateCityDefinition = record => ({
    type: UPDATE_CITY_DEFINITION,
    payload: record,
  })
  
  export const updateCityDefinitionSuccess = record => ({
    type: UPDATE_CITY_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const deleteCityDefinition = guid => ({
    type: DELETE_CITY_DEFINITION,
    payload: guid,
  })
  
  export const deleteCityDefinitionSuccess = guid => ({
    type: DELETE_CITY_DEFINITION_SUCCESS,
    payload: guid,
  })
  
  export const cityDefError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }
  
  